import i18n from '@/i18n'

export const defaultOption = {
  value: '',
  label: '',
  avatar: '',
}
export const defaultValues = {
  SuBH: defaultOption,
  SuOutOfBH: defaultOption,
  MoBH: defaultOption,
  MoOutOfBH: defaultOption,
  TuBH: defaultOption,
  TuOutOfBH: defaultOption,
  WeBH: defaultOption,
  WeOutOfBH: defaultOption,
  ThBH: defaultOption,
  ThOutOfBH: defaultOption,
  FrBH: defaultOption,
  FrOutOfBH: defaultOption,
  SaBH: defaultOption,
  SaOutOfBH: defaultOption,
}

export const prepareOptions = (arr, selectedItems = []) => {
  if (!arr.length) return arr
  return arr
    .map(({ user: { avatar, firstName, lastName, email }, phone }) => ({
      value: email,
      label: `${firstName} ${lastName}`,
      avatar,
      phone,
    }))
    .filter((item) => !!item.phone && !selectedItems.includes(item.value))
}

export const daysLong = [
  { day: i18n.t('on-call-schedule:days.sunday') },
  { day: i18n.t('on-call-schedule:days.monday') },
  { day: i18n.t('on-call-schedule:days.tuesday') },
  { day: i18n.t('on-call-schedule:days.wednesday') },
  { day: i18n.t('on-call-schedule:days.thursday') },
  { day: i18n.t('on-call-schedule:days.friday') },
  { day: i18n.t('on-call-schedule:days.saturday') },
]

export const daysShort = ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa']

export const escalationTimerOptions = [
  { value: 10, label: i18n.t('on-call-schedule:escalationTimer.minutes', { count: 10 }) },
  { value: 15, label: i18n.t('on-call-schedule:escalationTimer.minutes', { count: 15 }) },
  { value: 20, label: i18n.t('on-call-schedule:escalationTimer.minutes', { count: 20 }) },
  { value: 30, label: i18n.t('on-call-schedule:escalationTimer.minutes', { count: 30 }) },
]

export const emergencyOrderLabels = ['', 'first', 'second', 'third', 'forth', 'last']

export const buildEmergencyOrder = (levelsCount, timerValue, prevOrder = []) => {
  const newEmergencyOrder = []

  const defaultItem = {
    user: {
      avatar: '',
      value: '',
      label: '',
    },
    call: {
      attempt: 3,
      isEnabled: true,
    },
    sms: false,
    email: true,
    push: false,
  }

  const existingItemsByLabel = {}
  prevOrder.forEach((item) => {
    if (item.label === 'first' || item.label === 'last') {
      existingItemsByLabel[item.label] = item
    }
  })

  const existingMiddleItems = prevOrder.filter(
    (item) => item.label !== '' && item.label !== 'first' && item.label !== 'last',
  )

  const labels = ['', 'first']

  for (let i = 0; i < levelsCount; i++) {
    const labelIndex = i + 2
    const label = emergencyOrderLabels[labelIndex]
    labels.push(label)
  }

  labels.push('last')

  labels.forEach((label, index) => {
    let existingItem = {}

    if (label === 'first' || label === 'last') {
      existingItem = existingItemsByLabel[label] || {}
    } else if (label === '') {
      existingItem = {}
    } else {
      existingItem = existingMiddleItems[index - 2] || {}
    }

    let item = {
      ...defaultItem,
      ...existingItem,
      label,
      deletable: false,
    }

    if (label === '') {
      item.time = 0
    } else {
      item.time = index * timerValue

      if (label === 'first') {
        item.user = {
          avatar: 'on-call',
          label: i18n.t('on-call-schedule:onCallUser.label'),
          value: 'on-call',
        }
      } else if (label === 'last') {
        item.contactType = existingItem.contactType || 'internal'
        item.phoneNumber = existingItem.phoneNumber || ''
      } else {
        item.deletable = true
      }
    }

    newEmergencyOrder.push(item)
  })

  return newEmergencyOrder
}

export const validateUSPhoneNumber = (phoneNumber) => {
  const regex = /^[0-9]{10}$/
  return regex.test(phoneNumber)
}
